import { render, staticRenderFns } from "./ControlIndex.vue?vue&type=template&id=130d5374"
import script from "./ControlIndex.vue?vue&type=script&lang=js"
export * from "./ControlIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports